import { useState } from 'react';
import { useAuth, loginWithApple } from 'src/utils';
import '../profile.css';
import { Typography, Box, Button, AppleIcon } from 'src/components';
import { SocialLogin } from '@capgo/capacitor-social-login';
import { Capacitor } from '@capacitor/core';

export default function AppleAuthButton({ setLoading, handleCurrentViewChange, handleSuccess, showButtonText = true }) {
    const [errorMsg, setErrorMsg] = useState('');
    const { loginUser } = useAuth();

    // Detect platform
    const platform = Capacitor.getPlatform();
    const isAppleMobile = platform === 'ios'; 

    if (!isAppleMobile) return null;

    const handleNativeLogin = () => {
        setLoading(true);
        setErrorMsg('');

        SocialLogin.login({
            provider: 'apple',
            options: { scopes: ['email', 'name'] },
        })
        .then(async (res) => {
            console.log('APPLE SIGN IN RESULT', res);

            const idToken = res.result?.idToken;

            const { givenName, familyName } = res.result?.profile || {};
            const fullName = [givenName, familyName].filter(Boolean).join(' ');

            const backendRes = await loginWithApple(idToken, fullName);

            loginUser(backendRes.token, backendRes.refreshToken);
            handleSuccess('Logged in with Apple!');
            handleCurrentViewChange('AccountSummary');
        })
        .catch((err) => {
            console.log('Apple login failed', err);
            setErrorMsg(err.message || 'Apple login failed');
        })
        .finally(() => setLoading(false));
    };

    return (<>
        <Box
            sx={{
                width: '100%',
                display: 'flex',
                justifyContent: 'center',
                marginTop: 2,
            }}
            >
            <Button
                fullWidth
                variant="outlined"
                onClick={handleNativeLogin}
                sx={{
                    borderRadius: 1,
                    position: 'relative',
                    justifyContent: 'center',
                    backgroundColor: 'white',
                    color: '#6d6d6dff',
                    borderColor: '#ccc',
                    '&:hover': {
                        backgroundColor: '#f5f5f5',
                        borderColor: '#999',
                    },
                    '& .MuiButton-startIcon': {
                        position: 'absolute',
                        left: 22,
                        marginRight: 0,
                    },
                }}
                startIcon={showButtonText ? <AppleIcon /> : null}
            >
                {showButtonText ? <>Continue with Apple</> : <AppleIcon />}
            </Button>

        </Box>

        {errorMsg && <Typography variant="body3" color="error">{errorMsg}</Typography>}

    </>);
}
